import React from "react";
import { Box } from "@mui/material";

const Requests = () => {
  return (
    <Box
      sx={{
        height: "calc(100vh - 64px)",
        width: "100%",
      }}
    >
      <iframe
        src="https://requests.chezcora.com/"
        title="Requests"
        width="100%"
        height="100%"
        style={{
          border: "none",
        }}
      />
    </Box>
  );
};
export default Requests;
